<button type="button" class="{{ classes }}" [disabled]="isLoading" >
    <ng-container *ngIf="!isLoading">
        {{ initialText }}
    </ng-container>
    <ng-container *ngIf="isLoading">
        {{ loadingText }}

        <div class="spinner-border spinner-border-sm"></div>
    </ng-container>
</button>
